import {ITheme} from 'contexts/ThemeContext';
import {CreateResponsiveStyle} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle({
    container: {
      width: '100%',
      height: 56,
      backgroundColor: props.colors.white,
      borderBottomWidth: 1,
      borderBottomColor: props.colors.shadowGrey,
      boxShadow: `1px 1px 5px ${props.colors.shadowGrey}`,
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingRight: 20,
      zIndex: 9999,
    },
    leftPartContainer: {
      flexDirection: 'row',
    },
    screensContainer: {
      flexDirection: 'row',
    },
    itemContainer: {
      marginHorizontal: 8,
      paddingHorizontal: 8,
      height: 56,
      justifyContent: 'center',
    },
    iconContainer: {
      marginLeft: 30,
      marginRight: 16,
      marginTop: 5,
    },
    appIcon: {
      width: 46,
      height: 46,
    },
    text: {
      fontSize: 14,
      fontWeight: '500',
      color: props.colors.pickledBluewood,
    },
    activeLine: {
      width: '100%',
      height: 3,
      backgroundColor: props.colors.purple(1),
      borderRadius: 1,
      position: 'absolute',
      bottom: 0,
      left: 0,
    },
  })();
